import { render, staticRenderFns } from "./TaskBuildingList.vue?vue&type=template&id=368a7568&"
import script from "./TaskBuildingList.vue?vue&type=script&lang=js&"
export * from "./TaskBuildingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports